import React from 'react';
import { LinearProgress, Box } from '@mui/material';

/**
 * Dezente Loading-Anzeige für Routenwechsel.
 * Zeigt nur einen schmalen Fortschrittsbalken am oberen Bildschirmrand.
 * Wird als Suspense-Fallback für lazy-geladene Routen verwendet.
 */
const RouteLoadingIndicator = () => (
    <Box sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999
    }}>
        <LinearProgress
            sx={{
                height: 3,
                '& .MuiLinearProgress-bar': {
                    animationDuration: '1s'
                }
            }}
        />
    </Box>
);

export default RouteLoadingIndicator;
